<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Configuration</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Basic Information</a></li>
                    </ul>

                    <div v-show="oAuth2CallbackStatus === 'SUCCESS'" class="text-green-900 text-xl font-bold">
                        Successfully authenticated with your external accounting provider!
                    </div>
                    <div v-show="oAuth2CallbackStatus === 'ERROR'" class="text-red-900 text-xl font-bold">
                        Failed to authenticate with your external accounting provider!
                    </div>

                    <h3>Manage Basic Setup</h3>

                    <h3>Manage Company Information</h3>

                    <div class="field">
                        <label for="region">Region</label>
                        <Dropdown v-model="companyConfiguration.region" :options="regionTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Region"/>
                    </div>

                    <div class="field">
                        <label for="type">Account Type</label>
                        <Dropdown :disabled="true" v-model="companyConfiguration.type" :options="accountTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Account Type"/>
                    </div>

                    <div class="field">
                        <label for="language">Language</label>
                        <Dropdown v-model="companyConfiguration.language" :options="languageTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Language"/>
                    </div>

                    <div class="field">
                        <label for="requirePhone">Require a Dedicated Phone Number?</label>
                        <Dropdown v-model="companyConfiguration.requirePhone" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="requireWebsite">Require a New or Updated Website?</label>
                        <Dropdown v-model="companyConfiguration.requireWebsite" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="website">Website</label>
                        <InputText id="website" type="text" :disabled="false" v-model.trim="companyConfiguration.website"/>
                    </div>

                    <div v-show="companyConfiguration.type==='H'" class="field">
                        <label for="qualification">Qualification</label>
                        <InputText id="qualification" type="text" :disabled="false" v-model.trim="companyConfiguration.qualification"/>
                    </div>

                    <div v-show="companyConfiguration.type==='H'" class="field">
                        <label for="registrationNumber">Registration Number</label>
                        <InputText id="registrationNumber" type="text" :disabled="false" v-model.trim="companyConfiguration.registrationNumber"/>
                    </div>

                    <div v-show="companyConfiguration.type==='H'" class="field">
                        <label for="practiceNumber">Practice Number</label>
                        <InputText id="practiceNumber" type="text" :disabled="false" v-model.trim="companyConfiguration.practiceNumber"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Reminders Information</h3>

                    <div class="field">
                        <label for="requireWebsite">Enable Reminders using Email?</label>
                        <Dropdown v-model="companyConfiguration.enableRemindersEmail" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="requireWebsite">Enable Reminders using SMS?</label>
                        <Dropdown v-model="companyConfiguration.enableRemindersSms" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="requireWebsite">Enable Reminders using WhatsApp?</label>
                        <Dropdown v-model="companyConfiguration.enableRemindersWhatsapp" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="requireWebsite">Enable Reminders using Phone Calls?</label>
                        <Dropdown v-model="companyConfiguration.enableRemindersPhone" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="enableCopyOnAllEmails">Enable Copy On All Emails?</label>
                        <Dropdown v-model="companyConfiguration.enableCopyOnAllEmails" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>


                    <div style="height: 2rem;"></div>

                    <h3>Manage Client Configuration</h3>

                    <div class="field">
                        <label for="requireWebsite">Enable Automatic Client Activation from Digital Forms?</label>
                        <Dropdown v-model="companyConfiguration.enableAutoClientActivation" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Prepaid Information</h3>

                    <div class="field">
                        <label for="enablePrepaidReminderEmails">Enable Prepaid Reminder Emails?</label>
                        <Dropdown v-model="companyConfiguration.enablePrepaidReminderEmails" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div v-show="companyConfiguration.enablePrepaidReminderEmails === 'Y'" class="field">
                        <label for="amount">Prepaid Limit</label>
                        <InputNumber
                            id="amount"
                            v-model="companyConfiguration.prepaidLimit"
                            mode="decimal"
                            :min="0"
                            :maxFractionDigits="0"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Online Booking Information</h3>

                    <h4>Online Booking Link</h4>
                    <div class="field">
                        {{ this.companyConfiguration.onlineBookingLink }}
                    </div>

                    <div style="height: 0.5rem;"></div>

                    <div class="field">
                        <h4>Booking Time Frame (in weeks)</h4>
                        <InputNumber id="horizontal" v-model="companyConfiguration.bookingTimeFrame" showButtons
                                     buttonLayout="horizontal"
                                     :step="1"
                                     :min="1"
                                     :max="12"
                                     decrementButtonClass="p-button-danger"
                                     incrementButtonClass="p-button-success"
                                     incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                     mode="decimal"/>
                    </div>

                    <div class="field">
                        <h4>Delay from Starting Date (in days)</h4>
                        <InputNumber id="horizontal" v-model="companyConfiguration.startingDateDelay" showButtons
                                     buttonLayout="horizontal"
                                     :step="1"
                                     :min="1"
                                     :max="30"
                                     decrementButtonClass="p-button-danger"
                                     incrementButtonClass="p-button-success"
                                     incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
                                     mode="decimal"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Invoice Information</h3>

                    <h4>Starting Invoice Numbers and Prefix</h4>
                    <div class="field">
                        <label for="invoiceStartingNumber">Invoice Starting Number</label>
                        <InputText id="invoiceStartingNumber"
                                   v-model.trim="companyConfiguration.invoiceStartingNumber"
                                   required="false"/>
                        <small>Will only be active if there are no invoices yet in the account</small>
                    </div>

                    <div class="field">
                        <label for="invoicePrefix">Invoice Prefix</label>
                        <InputText id="invoicePrefix"
                                   v-model.trim="companyConfiguration.invoicePrefix"
                                   required="false"/>
                        <small>Will only be active for all new invoices</small>
                    </div>

                    <div class="field">
                        <label for="invoiceDisplayPractitioner">Display Practitioner Info on Invoices and Statements?</label>
                        <Dropdown v-model="companyConfiguration.invoiceDisplayPractitioner" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="useTaxRateForClaims">Use Tax Rate For Claims?</label>
                        <Dropdown v-model="companyConfiguration.useTaxRateForClaims" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                        <small>Will only be active if a tax number and tax rate is set, and will apply to both invoices and claims.</small>
                    </div>

                    <div style="height: 0.5rem;"></div>

                    <h4>Terms and Conditions</h4>

                    <div class="field">
                        <label for="addressPostalCode">Line #1</label>
                        <InputText id="termsLine1"
                                   v-model.trim="companyConfiguration.termsLine1"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Line #2</label>
                        <InputText id="termsLine2"
                                   v-model.trim="companyConfiguration.termsLine2"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Line #3</label>
                        <InputText id="termsLine3"
                                   v-model.trim="companyConfiguration.termsLine3"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="addressPostalCode">Line #4</label>
                        <InputText id="termsLine4"
                                   v-model.trim="companyConfiguration.termsLine4"
                                   required="false"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Calendar Information</h3>

                    <h4>Synchronization</h4>

                    <div class="field">
                        <label for="calSyncCalendar">Synchronize with Google/Microsoft Calendar</label>
                        <Dropdown v-model="companyConfiguration.calSyncCalendar" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                        <small>Note: If you have already authorized the system to send emails with your google or microsoft account in the past and the Test fails, then you will have to delete the token and re-authorize the system to also have access to your Google/Microsoft Calendar.</small>
                    </div>

                    <div class="field">
                        <label for="calSyncConferenceType">Conferencing Type</label>
                        <Dropdown v-model="companyConfiguration.calSyncConferenceType" :options="conferenceTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Type"/>
                        <small>Note: The Microsoft calendar integration only supports Teams Meeting currently.</small>
                    </div>

                    <div class="field">
                        <label for="calSyncSendUpdates">Send Calendar updates to attendees</label>
                        <Dropdown v-model="companyConfiguration.calSyncSendUpdates" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field">
                        <label for="calSyncConfPasscode">Zoom Pass Code</label>
                        <InputText id="calSyncConfPasscode"
                                   v-model.trim="companyConfiguration.calSyncConfPasscode"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="calSyncConfMeetingCode">Zoom Meeting Code</label>
                        <InputText id="calSyncConfMeetingCode"
                                   v-model.trim="companyConfiguration.calSyncConfMeetingCode"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="calSyncConfUri">Zoom Uri</label>
                        <InputText id="calSyncConfUri"
                                   v-model.trim="companyConfiguration.calSyncConfUri"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="calSyncEventPrefix">Event Prefix</label>
                        <InputText id="calSyncEventPrefix"
                                   v-model.trim="companyConfiguration.calSyncEventPrefix"
                                   required="false"/>
                    </div>


                    <div style="height: 2rem;"></div>

                    <h3>Manage Payment Imports</h3>

                    <div class="field">
                        <label for="paymentImportAutoEmailPaidInvoices">Automatically email paid invoices?</label>
                        <Dropdown v-model="companyConfiguration.paymentImportAutoEmailPaidInvoices" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Email Automation Integration using Sender</h3>

                    <div class="field">
                        <label for="enableSenderIntegration">Enable Sender Integration?</label>
                        <Dropdown v-model="companyConfiguration.enableSenderIntegration" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select a Status"/>
                    </div>

                    <div class="field" v-if="companyConfiguration.enableSenderIntegration === 'Y'">
                        <label for="senderApiToken">Sender API Token</label>
                        <InputText id="senderApiToken"
                                   v-model.trim="companyConfiguration.senderApiToken"
                                   required="false"/>
                    </div>

                    <div class="field" v-if="companyConfiguration.enableSenderIntegration === 'Y'">
                        <label for="senderGroupClient">Sender Group for Clients</label>
                        <InputText id="senderGroupClient"
                                   v-model.trim="companyConfiguration.senderGroupClient"
                                   required="false"/>
                    </div>

                    <div class="field" v-if="companyConfiguration.enableSenderIntegration === 'Y'">
                        <label for="senderGroupProspect">Sender Group for Prospects</label>
                        <InputText id="senderGroupProspect"
                                   v-model.trim="companyConfiguration.senderGroupProspect"
                                   required="false"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage PayFast Information</h3>

                    <div class="field">
                        <label for="payfastMerchantId">Merchant ID</label>
                        <InputText id="payfastMerchantId"
                                   v-model.trim="companyConfiguration.payfastMerchantId"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="payfastMerchantKey">Merchant Key</label>
                        <InputText id="payfastMerchantKey"
                                   v-model.trim="companyConfiguration.payfastMerchantKey"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="payfastMerchantPassphrase">Salt Passphrase</label>
                        <InputText id="payfastMerchantPassphrase"
                                   v-model.trim="companyConfiguration.payfastMerchantPassphrase"
                                   required="false"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage DNA Payments Information</h3>

                    <div class="field">
                        <label for="dnaPaymentsClientId">Client ID</label>
                        <InputText id="dnaPaymentsClientId"
                                   v-model.trim="companyConfiguration.dnaPaymentsClientId"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="dnaPaymentsClientSecret">Client Secret</label>
                        <InputText id="dnaPaymentsClientSecret"
                                   v-model.trim="companyConfiguration.dnaPaymentsClientSecret"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="dnaPaymentsTerminal">Terminal</label>
                        <InputText id="dnaPaymentsTerminal"
                                   v-model.trim="companyConfiguration.dnaPaymentsTerminal"
                                   required="false"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Stripe Information</h3>

                    <div class="field">
                        <label for="stripeEndpointSecret">Endpoint Secret</label>
                        <InputText id="stripeEndpointSecret"
                                   v-model.trim="companyConfiguration.stripeEndpointSecret"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="stripeApiSecret">Api Key</label>
                        <InputText id="stripeApiSecret"
                                   v-model.trim="companyConfiguration.stripeApiSecret"
                                   required="false"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Microsoft Teams</h3>

                    <div class="field">
                        <label for="msTeamsGroupId">Teams Group Id</label>
                        <InputText id="msTeamsGroupId"
                                   v-model.trim="companyConfiguration.msTeamsGroupId"
                                   required="false"/>
                    </div>

                    <div style="height: 2rem;"></div>

                    <h3>Manage Intuit Setup</h3>

                    <div class="field">
                        <label for="invCreatedDebitAccountId">Invoice Created Debit Account Id</label>
                        <InputText id="invCreatedDebitAccountId"
                                   v-model.trim="companyConfiguration.invCreatedDebitAccountId"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="invCreatedCreditAccountId">Invoice Created Credit Account Id</label>
                        <InputText id="invCreatedCreditAccountId"
                                   v-model.trim="companyConfiguration.invCreatedCreditAccountId"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="payCreatedDebitAccountId">Payment Created Debit Account Id</label>
                        <InputText id="payCreatedDebitAccountId"
                                   v-model.trim="companyConfiguration.payCreatedDebitAccountId"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label for="payCreatedCreditAccountId">Payment Created Credit Account Id</label>
                        <InputText id="payCreatedCreditAccountId"
                                   v-model.trim="companyConfiguration.payCreatedCreditAccountId"
                                   required="false"/>
                    </div>

                    <div class="field">
                        <label>Intuit OAuth2 Credential</label>

                        <div v-show="intuitOauth2Configuration.hasOAuth2Credential === 'Y'" class="card p-fluid">
                            <span class="text-green-600 font-bold">
                                Credentials found
                            </span>
                            <Button label="Delete Credentials" class="mr-2 mb-2" @click="deleteIntuitOAuth2Token"></Button>
                            <Button v-if="intuitAccountTypes.length === 0" label="Get Account Types" class="mr-2 mb-2" @click="getIntuitAccountTypes"></Button>
                            <Button v-if="intuitAccountTypes.length > 0" label="Hide Account Types" class="mr-2 mb-2" @click="hideIntuitAccountTypes"></Button>
                        </div>
                        <div v-show="intuitOauth2Configuration.hasOAuth2Credential === 'N'" class="card p-fluid">
                            <span class="text-red-600 font-bold">
                                No credentials found
                            </span>
                            <img src="images/intuit/C2QB_white_btn_lg_default.png" alt="Sign in with Intuit" style="display: block; height: 40px;" class="mr-2 mb-2" @click="doIntuitOAuth2" />
                        </div>

                        <div v-show="intuitAccountTypes.length > 0" class="card p-fluid">
                            <h2>Account Types</h2>
                            <DataTable :value="intuitAccountTypes" scrollable scrollHeight="200px" class="mt-6">
                                <Column field="id" header="Id" />
                                <Column field="name" header="Name"  />
                            </DataTable>
                        </div>
                    </div>

                    <div v-show="profile && profile.roles && profile.roles.includes('ROLE_ADMIN')">
                        <div style="height: 2rem;"></div>

                        <h3>Manage Email to Task Functionality</h3>

                        <div class="field">
                            <label for="enableEmailTaskProcessing">Enable Email to Task Processing?</label>
                            <Dropdown v-model="companyConfiguration.enableEmailTaskProcessing" :options="confirmationTypes"
                                      optionLabel="name"
                                      optionValue="code"
                                      placeholder="Select a Status"/>
                        </div>

                        <div v-show="companyConfiguration.enableEmailTaskProcessing === 'Y'" class="field">
                            <label for="taskProcess">Default Process for New Tasks</label>
                            <InputText id="taskProcess"
                                       v-model.trim="companyConfiguration.taskProcess"
                                       required="false"/>
                        </div>

                        <div v-show="companyConfiguration.enableEmailTaskProcessing === 'Y'" class="field">
                            <label for="taskRequesterUser">Default Requester User for New Tasks</label>
                            <InputText id="taskRequesterUser"
                                       v-model.trim="companyConfiguration.taskRequesterUser"
                                       required="false"/>
                        </div>

                        <div v-show="companyConfiguration.enableEmailTaskProcessing === 'Y'" class="field">
                            <label for="taskAssignedUser">Default Assigned User for New Tasks</label>
                            <InputText id="taskAssignedUser"
                                       v-model.trim="companyConfiguration.taskAssignedUser"
                                       required="false"/>
                        </div>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateConfiguration"></Button>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            intuitOauth2Configuration: {},
            intuitAccountTypes: [],
            oAuth2CallbackStatus: null,
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'United States', code: 'US'},
                {name: 'India', code: 'IN'}
            ],
            languageTypes: [
                {name: 'English', code: 'en'},
                {name: 'Afrikaans', code: 'af'}
            ],
            accountTypes: [
                {name: 'Healthcare Practitioner', code: 'H'},
                {name: 'Financial Advisor', code: 'F'},
                {name: 'Small Business', code: 'S'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            conferenceTypes: [
                {name: 'None', code: 'NONE'},
                {name: 'Google Meet', code: 'GOOGLE_MEET'},
                {name: 'Teams Meeting', code: 'TEAMS_MEETING'},
                {name: 'Zoom', code: 'ZOOM'}
            ],
            practitionerTypes: [
                {name: 'Occupational Therapist', code: 'A'},
                {name: 'Clinical Psychologist', code: 'B'},
                {name: 'Counselling Psychologist', code: 'C'},
                {name: 'Educational Psychologist', code: 'D'},
                {name: 'Industrial Psychologist', code: 'E'},
                {name: 'Psychologist', code: 'F'},
                {name: 'Psychiatrist', code: 'G'},
                {name: 'Social Worker', code: 'H'},
                {name: 'Registered Counsellor', code: 'I'},
                {name: 'Physiotherapist', code: 'J'},
                {name: 'Speech Therapist', code: 'K'},
                {name: 'Audiologist', code: 'L'},
                {name: 'Speech Therapist and Audiologist', code: 'M'},
                {name: 'Biokineticist', code: 'N'},
                {name: 'Dietician', code: 'O'},
                {name: 'Chiropractor', code: 'P'},
                {name: 'Podiatrist', code: 'Q'},
                {name: 'GP', code: 'R'},
                {name: 'Dentist', code: 'S'},
                {name: 'Specialist Physician', code: 'T'},
                {name: 'Other', code: 'U'}
            ]
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[ConfigurationBasic][loadCompanyContext] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;
                console.log("[ConfigurationBasic][loadCompanyContext] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[ConfigurationBasic][loadCompanyContext] Could not find user config for user = ", this.userStore.user.id);
            }

            try {
                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                console.log("[ConfigurationBasic][loadCompanyContext] companyConfigData.data = ", companyConfigData.data);

            } catch (e) {
                console.error("[ConfigurationBasic][loadCompanyContext] Error fetching additional data = ", e);
            }

            console.log("[ConfigurationBasic][loadCompanyContext] this.userConfiguration = ", this.userConfiguration);
            console.log("[ConfigurationBasic][loadCompanyContext] this.companyConfiguration = ", this.companyConfiguration);

            try {
                const [response] = await Promise.all([
                    CompanyService.hasIntuitOAuth2Token(this.profile.companyId)
                ]);

                this.intuitOauth2Configuration = response.data.data;
                console.log("[ConfigurationBasic][loadCompanyContext] this.intuitOauth2Configuration = ", this.intuitOauth2Configuration);
            } catch (e) {
                console.error("[ConfigurationEmail][loadCompanyContext] Error fetching intuit oauth2 credential data = ", e);
            }

            if (this.$route.query.oAuth2CallbackStatus) {
                this.oAuth2CallbackStatus = this.$route.query.oAuth2CallbackStatus;
                console.log('[ConfigurationEmail][loadCompanyContext] Found this.oAuth2CallbackStatus = ', this.oAuth2CallbackStatus)
            }
        },
        async updateConfiguration() {

            const value = Number(this.companyConfiguration.invoiceStartingNumber);

            this.companyConfiguration.invoiceStartingNumber =
                Number.isFinite(value) && value > 0
                    ? value
                    : 1;

            var updatedConfiguration = {
                region: this.companyConfiguration.region,
                type: this.companyConfiguration.type,
                language: this.companyConfiguration.language,
                practitionerType: this.companyConfiguration.practitionerType,
                requirePhone: this.companyConfiguration.requirePhone,
                requireWebsite: this.companyConfiguration.requireWebsite,
                website: this.companyConfiguration.website,
                qualification: this.companyConfiguration.qualification,
                registrationNumber: this.companyConfiguration.registrationNumber,
                practiceNumber: this.companyConfiguration.practiceNumber,
                enableRemindersEmail: this.companyConfiguration.enableRemindersEmail,
                enableRemindersSms: this.companyConfiguration.enableRemindersSms,
                enableRemindersWhatsapp: this.companyConfiguration.enableRemindersWhatsapp,
                enableRemindersPhone: this.companyConfiguration.enableRemindersPhone,
                enableCopyOnAllEmails: this.companyConfiguration.enableCopyOnAllEmails,
                enablePrepaidReminderEmails: this.companyConfiguration.enablePrepaidReminderEmails,
                enableAutoClientActivation: this.companyConfiguration.enableAutoClientActivation,
                prepaidLimit: this.companyConfiguration.prepaidLimit,
                termsLine1: this.companyConfiguration.termsLine1,
                termsLine2: this.companyConfiguration.termsLine2,
                termsLine3: this.companyConfiguration.termsLine3,
                termsLine4: this.companyConfiguration.termsLine4,
                bookingTimeFrame: this.companyConfiguration.bookingTimeFrame,
                startingDateDelay: this.companyConfiguration.startingDateDelay,
                invoiceStartingNumber: this.companyConfiguration.invoiceStartingNumber,
                invoicePrefix: this.companyConfiguration.invoicePrefix,
                invoiceDisplayPractitioner: this.companyConfiguration.invoiceDisplayPractitioner,
                calSyncCalendar: this.companyConfiguration.calSyncCalendar,
                calSyncSendUpdates: this.companyConfiguration.calSyncSendUpdates,
                calSyncConfPasscode: this.companyConfiguration.calSyncConfPasscode,
                calSyncConfMeetingCode: this.companyConfiguration.calSyncConfMeetingCode,
                calSyncConfUri: this.companyConfiguration.calSyncConfUri,
                calSyncEventPrefix: this.companyConfiguration.calSyncEventPrefix,
                calSyncConferenceType: this.companyConfiguration.calSyncConferenceType,
                useTaxRateForClaims: this.companyConfiguration.useTaxRateForClaims,
                enableSenderIntegration: this.companyConfiguration.enableSenderIntegration,
                senderApiToken: this.companyConfiguration.senderApiToken,
                senderGroupClient: this.companyConfiguration.senderGroupClient,
                senderGroupProspect: this.companyConfiguration.senderGroupProspect,
                paymentImportAutoEmailPaidInvoices: this.companyConfiguration.paymentImportAutoEmailPaidInvoices,
                dnaPaymentsClientId: this.companyConfiguration.dnaPaymentsClientId,
                dnaPaymentsClientSecret: this.companyConfiguration.dnaPaymentsClientSecret,
                dnaPaymentsTerminal: this.companyConfiguration.dnaPaymentsTerminal,
                stripeEndpointSecret: this.companyConfiguration.stripeEndpointSecret,
                stripeApiSecret: this.companyConfiguration.stripeApiSecret,
                msTeamsGroupId: this.companyConfiguration.msTeamsGroupId,
                invCreatedDebitAccountId: this.companyConfiguration.invCreatedDebitAccountId,
                invCreatedCreditAccountId: this.companyConfiguration.invCreatedCreditAccountId,
                payCreatedDebitAccountId: this.companyConfiguration.payCreatedDebitAccountId,
                payCreatedCreditAccountId: this.companyConfiguration.payCreatedCreditAccountId,
                payfastMerchantId: this.companyConfiguration.payfastMerchantId,
                payfastMerchantKey: this.companyConfiguration.payfastMerchantKey,
                payfastMerchantPassphrase: this.companyConfiguration.payfastMerchantPassphrase,
                enableEmailTaskProcessing: this.companyConfiguration.enableEmailTaskProcessing,
                taskProcess: this.companyConfiguration.taskProcess,
                taskRequesterUser: this.companyConfiguration.taskRequesterUser,
                taskAssignedUser: this.companyConfiguration.taskAssignedUser
            }

            console.log("[ConfigurationBasic][updateConfiguration] Updated configuration. Data = ", updatedConfiguration);

            this.activeTab = 2;

            try {
                const response = await CompanyService.updateCompanyConfiguration(this.profile.companyId, updatedConfiguration);
                console.log('[ConfigurationBasic][updateConfiguration] Response = ', response);

                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                this.userStore.setCompanyConfiguration(companyConfigData.data);
                console.log("[ConfigurationBasic][updateConfiguration] companyConfigData.data = ", companyConfigData.data);

                if (this.companyConfiguration.manualClientIntakeForms == null) {
                    this.companyConfiguration.manualClientIntakeForms = 'Y';
                }

                if (this.companyConfiguration.manualBillingInstructions == null) {
                    this.companyConfiguration.manualBillingInstructions = 'Y';
                }

                if (this.companyConfiguration.weeklyNewClients == null) {
                    this.companyConfiguration.weeklyNewClients = 1;
                }

                if (this.companyConfiguration.weeklyWorkingDays == null) {
                    this.companyConfiguration.weeklyWorkingDays = 4;
                }

                if (this.companyConfiguration.weeklyBillableAppointments == null) {
                    this.companyConfiguration.weeklyBillableAppointments = 3;
                }

                if (this.companyConfiguration.clientSplit == null) {
                    this.companyConfiguration.clientSplit = 80;
                }

                if (this.companyConfiguration.monthlyBankStatements == null) {
                    this.companyConfiguration.monthlyBankStatements = 1;
                }

                if (this.companyConfiguration.bankStatementSize == null) {
                    this.companyConfiguration.bankStatementSize = 3;
                }

                if (this.companyConfiguration.monthlyRemittances == null) {
                    this.companyConfiguration.monthlyRemittances = 4;
                }

                if (this.companyConfiguration.remittanceSize == null) {
                    this.companyConfiguration.remittanceSize = 2;
                }

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (error) {
                console.error('[ConfigurationBasic][updateConfiguration] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        },
        async doIntuitOAuth2() {
            try {
                const [response] = await Promise.all([
                    CompanyService.intuitGetAuthUrl(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][doIntuitOAuth2] data = ", response.data);

                // redirect
                if (response.data.data.url) {
                    window.top.location.href = response.data.data.url;
                }
            } catch(error) {
                console.error('[ConfigurationEmail][doIntuitOAuth2] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to start intuit authentication process. Please try again.',
                    life: 3000
                });
            }
        },
        async deleteIntuitOAuth2Token() {
            try {
                const [response] = await Promise.all([
                    CompanyService.deleteIntuitOAuth2Token(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][deleteIntuitOAuth2Token] response  = ", response);

                const [response2] = await Promise.all([
                    CompanyService.hasIntuitOAuth2Token(this.profile.companyId)
                ]);

                this.intuitOauth2Configuration = response2.data.data;
            } catch(error) {
                console.error('[ConfigurationEmail][deleteIntuitOAuth2Token] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to delete intuit authentication credentials. Please try again.',
                    life: 3000
                });
            }
        },
        async getIntuitAccountTypes() {
            try {
                const [response] = await Promise.all([
                    CompanyService.getIntuitAccountTypes(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][getIntuitAccountTypes] response  = ", response);

                this.intuitAccountTypes = response.data;
            } catch(error) {
                console.error('[ConfigurationEmail][getIntuitAccountTypes] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to get account types. Please try again.',
                    life: 3000
                });
            }
        },
        hideIntuitAccountTypes() {
            this.intuitAccountTypes = [];
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
